import { render, staticRenderFns } from "./ShInforList.vue?vue&type=template&id=515d939f&scoped=true"
import script from "./ShInforList.vue?vue&type=script&lang=js"
export * from "./ShInforList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d939f",
  null
  
)

export default component.exports